var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-3 p-2 field d-flex justify-content-between align-items-center"},[_c('div',[_c('h5',{staticClass:"m-0"},[_vm._v(" "+_vm._s(_vm.$t(_vm.label))+" ")]),_c('small',{staticClass:"font-italic text-muted"},[_vm._v(_vm._s(_vm.$t(_vm.description)))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }